import { render, staticRenderFns } from "./component-a4c86042.vue?vue&type=template&id=b5e53adc&scoped=true&"
import script from "./component-a4c86042.vue?vue&type=script&lang=js&"
export * from "./component-a4c86042.vue?vue&type=script&lang=js&"
import style0 from "./component-a4c86042.vue?vue&type=style&index=0&id=b5e53adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e53adc",
  null
  
)

export default component.exports